
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gSidJJfBXk_nsN_45NEPAIRu_7e7_45efvo8dyQwUGZqQJ_kMeta } from "/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexiUqoF8lKQO5mlp4_7VTcPLMl9MSJRkT6mwpIRha_45pNMMeta } from "/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchRO6PWlvUx1LNRncKhVwiRcr8NTar6LKlwlQxLU8EbxgMeta } from "/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index1E4RwD_45H8Caz_45AxP1Bs3ttw3Xp3WilyRgef9PKnuVCEMeta } from "/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93p6EfaJ_457ltO023usOPZsIjdEumny4fqzGROnNcIs_jwMeta } from "/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexjFirLm9eN3ou0nfwjbz__45CvAwwcBUB1maUbjt5EDn48Meta } from "/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93M_zajcEt69FE8jqeJG3v5hxspwYquvXyqHIp6mlfM2kMeta } from "/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexdMmTkAR_RpknrQBTuQJWUPZzqPyZJUvvah1eBxy_45mKIMeta } from "/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93MPZam_EJCEs2uYhf4EFBIfTgokhKDCQL8QHF_AsisdgMeta } from "/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexs8erc9cu1xa6_JObv7eC66rWuJH1BMrMoQhlEsdbp18Meta } from "/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index1gOcBnGFzs6gYUbs6wX4b6UabWNvYAScxbed12N5vhAMeta } from "/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexjFirLm9eN3ou0nfwjbz__45CvAwwcBUB1maUbjt5EDn48Meta || {},
    component: () => import("/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexdMmTkAR_RpknrQBTuQJWUPZzqPyZJUvvah1eBxy_45mKIMeta || {},
    component: () => import("/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexs8erc9cu1xa6_JObv7eC66rWuJH1BMrMoQhlEsdbp18Meta || {},
    component: () => import("/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index1gOcBnGFzs6gYUbs6wX4b6UabWNvYAScxbed12N5vhAMeta || {},
    component: () => import("/codebuild/output/src2897041213/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]